import { Box } from "@mui/material";
import type {
  CurrencySource,
  NegativeValueAs,
  NumberFormatterOptions,
  ZeroValueAs,
} from "../../../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { CurrencyDimensionMeta } from "../../../../../../../../../../api/types/svTypes.ts";
import Abbreviation from "./parts/Abbreviation.tsx";
import CurrencySourceSelector from "./parts/CurrencySourceSelector.tsx";
import Decimals from "./parts/Decimals.tsx";
import NegativeValue from "./parts/NegativeValue.tsx";
import ZeroValue from "./parts/ZeroValue.tsx";

interface Props {
  referenceDimensionName: string | undefined;
  currencySymbol?: string;
  currencySource: CurrencySource;
  sampleFormatOptions: NumberFormatterOptions;
  currencyDimensions: CurrencyDimensionMeta[];
  onReferenceDimensionNameChange: (referenceDimensionName: string) => void;
  onAbbreviationChange: (options: NumberFormatterOptions) => void;
  onDecimalsChange: (options: NumberFormatterOptions) => void;
  onCurrencySourceChange: (currencySource: CurrencySource) => void;
  onCurrencySymbolChange: (currencySymbol: string) => void;
  onNegativeValueChanged: (showAs: NegativeValueAs) => void;
  onZeroValueChanged: (showAs: ZeroValueAs) => void;
}
const CurrencyCustomFormat = ({
  referenceDimensionName,
  currencySymbol,
  sampleFormatOptions,
  currencySource,
  currencyDimensions,
  onReferenceDimensionNameChange,
  onAbbreviationChange,
  onDecimalsChange,
  onCurrencySourceChange,
  onCurrencySymbolChange,
  onNegativeValueChanged,
  onZeroValueChanged,
}: Props) => {
  return (
    <>
      <CurrencySourceSelector
        referenceDimensionName={referenceDimensionName}
        currencySource={currencySource}
        currencyCode={currencySymbol}
        onReferenceDimensionNameChange={onReferenceDimensionNameChange}
        onCurrencyCodeChange={onCurrencySymbolChange}
        onCurrencySourceChange={onCurrencySourceChange}
        currencyDimensions={currencyDimensions}
      />

      <Abbreviation formatOptions={sampleFormatOptions} applyFormat={onAbbreviationChange} />
      <Box sx={{ display: "flex", pt: ".5rem", gap: ".5rem" }}>
        <Decimals formatOptions={sampleFormatOptions} applyFormat={onDecimalsChange} />
      </Box>
      <NegativeValue value={sampleFormatOptions.showNegativeValuesAs} onNegativeValueChanged={onNegativeValueChanged} />
      <ZeroValue value={sampleFormatOptions.showZeroValuesAs} onZeroValueChanged={onZeroValueChanged} />
    </>
  );
};

export default CurrencyCustomFormat;
